import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Intake } from 'models/IntakeModel';
import { ExamField as EMF } from 'constants/codes';
import { INITIAL_JSON_STATE, IntakeJsonData} from 'models/IntakeOnlineData';


const IntakeForm: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.INTAKE, Code.Form.Name.INTAKE];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [formData, setFormData] = useState<Intake>({});
  const [jsonData, setJsonData] = useState<IntakeJsonData>(INITIAL_JSON_STATE);
  const [cityOptions, setCityOptions] = Hooks.Form.Options();

  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    Files.Json.API(Code.File.CITY, Code.Option.Common.NA, setCityOptions, setError);
  
    API.Data.GetByKeyId<Intake>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.intake_active); 
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));
        const tempData = (data as any)['intake_data'];
        const tempExamData = JSON.parse(tempData.replace(/\r?\n/g, "\\n"))
        setJsonData(tempExamData);
        console.log("intake-data:",data);
      }})
      setLoading(false);
  }, []);

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
      intake_first_name: Utility.Convert.TitleCase(formData.intake_first_name),
      intake_last_name: Utility.Convert.TitleCase(formData.intake_last_name),
      intake_data: Utility.Clean.JsonObject(jsonData),
    });

    //console.log("------------------>",finalData);

    API.Data.Save(formName, keyId, finalData, setMessage)
  };

  const handleCopyAll = () => {
  let copyData = "";
  let dvalue;
  Code.Exam.FieldGroup.IntakeFields.forEach((field, index) => {
    const inputElement = document.getElementById(field) as HTMLInputElement | null;
    dvalue = inputElement?.value
    if (dvalue) {
      if(field == "intake_first_name") field = "client_first_name";
      else if(field == "intake_last_name") field = "client_last_name";
      else if(field == "intake_health_card") field = "client_health_card";
      else if(field == "intake_dob") field = "client_dob";
      else if(field == "intake_phone") field = "client_phone";
      else if(field == "intake_email") field = "client_email";
      else if(field == "intake_gender"){
        field = "gender_id";
        if(dvalue=="Male") dvalue = "10";
        else if(dvalue=="Female") dvalue = "11";
      } 
      else if(field == "intake_city"){
        field = "city_id";
        dvalue = "10";
      }
      else if(field == "intake_address") field = "client_address";
      else if(field == "intake_postal") field = "client_postal";
      else if(field == "D86") field = "insurance_policy_number";
      else if(field == "D87") field = "insurance_group_number";
      else if(field == "D88") field = "secondary_relationship";
      copyData += `${field}::${dvalue};;`;
    }
  });
  copyData = copyData.replaceAll("'","''");
  //navigator.clipboard.writeText(copyData);
  navigator.clipboard.writeText(btoa(copyData));
};

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} formName={formName} formId={formId} Privilege={Privilege}>
            <span className='fright copyall' onClick={handleCopyAll} title="Copy All Fields"></span>
          </Button.Save>
          <Control.Tab.Header titles={["Personal","Health","Insurance","Emergency"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
 
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
               <Control.Row>
                <Field.Text id={Name.Intake.FirstName} value={formData.intake_first_name} title="First Name" onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true}  />
                <Field.Text id={Name.Intake.LastName} value={formData.intake_last_name} title="Last Name" onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
              <Control.Row>
                <Field.Text id={Name.Intake.Phone} value={formData.intake_phone} title={Title.Phone} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]}  />
                <Field.Text id={Name.Intake.Email} value={formData.intake_email} title={Title.Email} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
              <Control.Row>
                <Field.Text id={Name.Intake.Gender} value={formData.intake_gender} title={Title.Gender} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]}  />
                <Field.Text id={Name.Intake.ExistingPatient} value={Utility.Get.FieldValue(jsonData, EMF.Intake.Existing as keyof IntakeJsonData)} title="Existing Patient" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)} size={[1,50,0]} />
              </Control.Row>
              <Control.Row>
                <Field.Text id={Name.Intake.HCNO} value={formData.intake_health_card} title="Health Card Number" onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]}  />
                <Field.Text id={Name.Intake.DOB} value={formData.intake_dob ? Utility.Format.DateOnly(new Date(formData.intake_dob)) : formData.intake_dob} title="Date of Birth" onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
               <Control.Row>
                <Field.Area id={Name.Intake.Address} value={formData.intake_address} title={Title.Address} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Row>
              <Control.Row>
                <Field.Text id={Name.Intake.City} value={formData.intake_city} title={Title.City} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,40,1]} />
                <Field.Text id={Name.Intake.Province} value={formData.intake_province} title={Title.Province} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,20,1]} />
                <Field.Text id={Name.Intake.Postal} value={formData.intake_postal} title={Title.Postal} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,40,1]} />
              </Control.Row>
           </Control.Tab.Content>

           <Control.Tab.Content id={Code.Tab.Tab2} isActive={activeTab === Code.Tab.Tab2}>
              <Control.Row>
                <Field.Area id={Name.Intake.ReasonforVisit} value={Utility.Get.FieldValue(jsonData, EMF.Intake.ReasonforVisit as keyof IntakeJsonData)} title="Reason for Visit"  onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)}   />
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.Intake.Symptoms} value={Utility.Get.FieldValue(jsonData, EMF.Intake.Symptoms as keyof IntakeJsonData)} title="Symptoms" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)}  />
              </Control.Row>
              <Control.Row>
                <Field.Text id={Name.Intake.Smoker} value={Utility.Get.FieldValue(jsonData, EMF.Intake.Smoker as keyof IntakeJsonData)} title="Smoker?" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)} size={[0,50,1]} />
                <Field.Text id={Name.Intake.Pregnant} value={Utility.Get.FieldValue(jsonData, EMF.Intake.Pregnant as keyof IntakeJsonData)} title="Pregnant?" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)} size={[1,50,0]} />
              </Control.Row>
              <Control.Row>
                <Field.Text id={Name.Intake.Diabetic} value={Utility.Get.FieldValue(jsonData, EMF.Intake.Diabetic as keyof IntakeJsonData)} title="Diabetic?" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)} size={[0,50,1]} />
                <Field.Text id={Name.Intake.BloodSugarLevel} value={Utility.Get.FieldValue(jsonData, EMF.Intake.BloodSugarLevel as keyof IntakeJsonData)} title="Blood Sugar Level" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)} size={[1,50,0]} />
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.Intake.EyeInjury} value={Utility.Get.FieldValue(jsonData, EMF.Intake.EyeInjury as keyof IntakeJsonData)} title="Eye injury?" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)} />
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.Intake.EyeSurgery} value={Utility.Get.FieldValue(jsonData, EMF.Intake.EyeSurgery as keyof IntakeJsonData)} title="Eye Surgery" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)}  />
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.Intake.MedicalConditions} value={Utility.Get.FieldValue(jsonData, EMF.Intake.MedicalConditions as keyof IntakeJsonData)} title="Medical Conditions" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)}  />
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.Intake.CurrentMedications} value={Utility.Get.FieldValue(jsonData, EMF.Intake.CurrentMedications as keyof IntakeJsonData)} title="Current Medications" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)}  />
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.Intake.Allergies} value={Utility.Get.FieldValue(jsonData, EMF.Intake.Allergies as keyof IntakeJsonData)} title="Allergies?" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)}  />
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.Intake.FamilyHistory} value={Utility.Get.FieldValue(jsonData, EMF.Intake.FamilyHistory as keyof IntakeJsonData)} title="Family History" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)}  />
              </Control.Row>
            </Control.Tab.Content>

            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab3}>
              <Field.Text id={Name.Intake.InsurerName} value={Utility.Get.FieldValue(jsonData, EMF.Intake.InsurerName as keyof IntakeJsonData)} title="Insurer Name" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)} />
              <Field.Text id={Name.Intake.PolicyNumber} value={Utility.Get.FieldValue(jsonData, EMF.Intake.PolicyNumber as keyof IntakeJsonData)} title="Policy Number" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)} />
              <Field.Text id={Name.Intake.GroupNumber} value={Utility.Get.FieldValue(jsonData, EMF.Intake.GroupNumber as keyof IntakeJsonData)} title="Group Number" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)} />
              <Field.Text id={Name.Intake.RelationtoPolicyholder} value={Utility.Get.FieldValue(jsonData, EMF.Intake.RelationtoPolicyholder as keyof IntakeJsonData)} title="Relation to Policyholder" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)} />
            </Control.Tab.Content>

            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab4}>
              <Field.Text id={Name.Intake.EmergencyContactName} value={Utility.Get.FieldValue(jsonData, EMF.Intake.EmergencyContactName as keyof IntakeJsonData)} title="Contact Person Name" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)} />
              <Field.Text id={Name.Intake.EmergencyRelationship} value={Utility.Get.FieldValue(jsonData, EMF.Intake.EmergencyRelationship as keyof IntakeJsonData)} title="Relationship" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)} />
              <Field.Text id={Name.Intake.EmergencyContactPhone} value={Utility.Get.FieldValue(jsonData, EMF.Intake.EmergencyContactPhone as keyof IntakeJsonData)} title="Contact Phone" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)}/>
              <Field.Text id={Name.Intake.EmergencyAlternativePhone} value={Utility.Get.FieldValue(jsonData, EMF.Intake.EmergencyAlternativePhone as keyof IntakeJsonData)} title="Alternative Phone" onChange={(e) => Form.MultiValue.Change(e, jsonData, setJsonData)} />
            </Control.Tab.Content>
            
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default IntakeForm;